import type { FC } from 'react';
import { Link } from 'react-router-dom';
import classes from './SimeraNavTab.module.css';

interface SimeraNavTabProps {
  isActive: boolean;
  route: string;
  text: string;
  testId?: string;
}

const SimeraNavTab: FC<SimeraNavTabProps> = ({
  isActive,
  route,
  text,
  testId,
}) => {
  return (
    <Link
      to={route}
      aria-hidden
      className={`${classes.Positions} ${isActive && classes.ActiveNavItem}`}
      {...(testId && { 'data-testid': testId })}
    >
      <p>{text}</p>
    </Link>
  );
};

SimeraNavTab.defaultProps = {
  testId: undefined,
};

export default SimeraNavTab;
